// extracted by mini-css-extract-plugin
export var chip = "_48-9";
export var chipLabel = "_48-a";
export var close = "_48-7";
export var closeIcon = "_48-8";
export var error = "_48-6";
export var infoTooltip = "_48-2";
export var innerContainer = "_48-1";
export var input = "_48-b";
export var medium = "_48-5";
export var outerContainer = "_48-0";
export var small = "_48-4";
export var xSmall = "_48-3";